window.addEventListener('load', function () {
    const activeList = document.getElementsByClassName('active_btn');
    let sideContainer = document.querySelector(".sidebar");

    let getCookieValue = (name) => (
        document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
    )

    if(sideContainer)
    {
        if(getCookieValue('menu') == 'open')
        {
            document.getElementById('sidebar').classList.remove('d-none');
            document.getElementById('open_menu').classList.add('d-none');
        }
        else if(getCookieValue('menu') == 'close')
        {
            document.getElementById('sidebar').classList.add('d-none');
            document.getElementById('open_menu').classList.remove('d-none');
        }
        else 
        {
            if (document.getElementById('sidebar') ) {
                document.getElementById('sidebar').classList.remove('d-none');
            }

            if (document.getElementById('open_menu')) {
                document.getElementById('open_menu').classList.add('d-none');
            }
        }

        if(activeList.length>0){
            toggleList(activeList[0]);
        }
        let sidebar = document.querySelectorAll('.head-side-bar')
        if(sidebar){
            sidebar.forEach(item => {
                item.addEventListener('click', event => {
                    const showing_list = sideContainer.querySelectorAll(".show");
                    const id = event.target.getAttribute('id');
                    if (showing_list[0] != null && showing_list[0].id != `side_${id}`){
                        let parent_id = showing_list[0].id.split("_");
                        let showing_menu = document.getElementById(parent_id[1]);
                        toggleList(showing_menu);
                    }
                    toggleList(event.target);
                });
            });
        }
    }
});

toggleList = function(that) {
    const img = document.getElementById(that.id);
    const list = document.getElementsByClassName('side_'+that.id)
    const buttons = document.getElementsByClassName('side_'+that.id);

    if (img != null && list.length > 0 && buttons.length > 0){
        img.lastElementChild.classList.toggle('rotateimg180');
        list[0].classList.toggle('hide');
        list[0].classList.toggle('show');
        let children = buttons[0].children
        let s;

        for (s = 0; s < children.length; s++){
            children[s].classList.toggle('active_list');
        }
    }
}

closeMenu = function(event) {
    event.preventDefault();
    document.getElementById('sidebar').classList.add('d-none');
    document.getElementById('open_menu').classList.remove('d-none');
    document.cookie = "menu=close";
}

openMenu = function(event) {
    event.preventDefault();
    document.getElementById('sidebar').classList.remove('d-none');
    document.getElementById('open_menu').classList.add('d-none');
    document.cookie = "menu=open";
}